import { render, staticRenderFns } from "./CareerDetails.vue?vue&type=template&id=66ad9162&scoped=true"
import script from "./CareerDetails.vue?vue&type=script&lang=js"
export * from "./CareerDetails.vue?vue&type=script&lang=js"
import style0 from "./CareerDetails.vue?vue&type=style&index=0&id=66ad9162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad9162",
  null
  
)

export default component.exports